import { Alert, colors, IMSwissSelect, OverlaySpinner, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const GroupNameStyled = styled.b`
  color: ${colors.blue[700]};
`;

export const ContentStyled = styled.div`
  width: 100%;
`;

export const FormWrapperStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  border-top: 1px solid ${colors.neutral[300]};
  padding-top: 1.4rem;
`;

export const CurrentAgencyBlockStyled = styled.div`
  padding: 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: ${colors.neutral[100]};
  border-radius: 10px;
  margin-bottom: 2rem;
`;

export const CurrentAgencyLabelStyled = styled.h3`
  ${typography.regular[16]};
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const CurrentAgencyStyled = styled.h3`
  ${typography.bold[16]};
  color: ${colors.neutral[900]};
  margin: 0;
`;

export const AssigneesBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
`;

export const AssigneesFieldStyled = styled.div`
  position: relative;
`;

export const AssigneesSpinnerStyled = styled(OverlaySpinner)`
  inset: 2.8rem 4rem auto auto;
  width: 2rem;
  height: 4.6rem;
`;

export const IMSwissSelectStyled = styled(IMSwissSelect)`
  width: 100%;
`;

export const AlertInfoMessageStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const AlertStyled = styled(Alert)`
  border-radius: 4px;
`;
